import { ReactNode, useMemo, useState } from 'react'

import { type AssessmentMode } from './ag-grid-assessment/config/modes'
import { AssessmentContext } from './assessment-context'

interface AssessmentProviderProps {
  children: ReactNode
  mode: AssessmentMode
}

export const AssessmentProvider = ({ children, mode }: AssessmentProviderProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [assessmentId, setAssessmentId] = useState('')
  const [companyId, setCompanyId] = useState('')
  const [startingAssessmentId, setStartingAssessmentId] = useState<string | null>(null)

  const openDeleteModal = ({
    companyId,
    ongoingAssessmentId,
  }: {
    companyId: string
    ongoingAssessmentId: string
  }) => {
    setCompanyId(companyId)
    setAssessmentId(ongoingAssessmentId)
    setIsOpen(true)
  }

  const value = useMemo(
    () => ({
      isOpen,
      setIsOpen,
      assessmentId,
      setAssessmentId,
      companyId,
      setCompanyId,
      openDeleteModal,
      startingAssessmentId,
      setStartingAssessmentId,
      mode,
    }),
    [isOpen, assessmentId, companyId, startingAssessmentId, mode],
  )

  return <AssessmentContext.Provider value={value}>{children}</AssessmentContext.Provider>
}
